import { useAuth } from "../api/authUtils/AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import React, { useEffect, useRef } from "react";

export default function Switcher({ before, after }) { 
  const { user, sessionExpired } = useAuth();
  const location = useLocation();
  const isAlreadyOnLogin = location.pathname === '/login';
  const wasLoggedInRef = useRef(false);

  useEffect(() => {
    if (user) {
      wasLoggedInRef.current = true;
    }
  }, [user]);
  // Session expired, redirect to login
  if (!user && sessionExpired && wasLoggedInRef.current && !isAlreadyOnLogin) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }
  return user ? after : before;
}
